import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvelopeService } from '../../envelope/services/envelope.service';
import { SentEnvelopeFilter } from '../../envelope/model/sent-envelope-filter';
import { SentEnvelopeStatus } from '../../enum/sent-envelope-status';
import { SentEnvelopeSortStorageService } from '../../envelope/services/sent-envelope-sort-storage.service';

@Injectable({
  providedIn: 'root'
})

export class SentResolverService implements Resolve<Observable<any>> {
  constructor(
    private _envelopeService: EnvelopeService,
    private sentEnvelopeSortStorageService: SentEnvelopeSortStorageService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
    const startEnvelopeFilter = this.createStartEnvelopeFilter();

    return forkJoin({
      statusCounter: this._envelopeService.getSentEnvelopeStatusCounter(startEnvelopeFilter).pipe(catchError(this.errorCalling)),
      list: this._envelopeService.filterElements(startEnvelopeFilter).pipe(catchError(this.errorCalling)),
    });
  }

  errorCalling = (err) => {
    console.log('Error Getting data: ', err);
    return err;
  };

  private createStartEnvelopeFilter(): SentEnvelopeFilter {
    const startEnvelopeFilter = new SentEnvelopeFilter();
    const sortSelection = this.sentEnvelopeSortStorageService.getForStatus(SentEnvelopeStatus.pending);

    startEnvelopeFilter.status = SentEnvelopeStatus.pending;
    startEnvelopeFilter.skip = 0;
    startEnvelopeFilter.take = 25;
    startEnvelopeFilter.sortField = sortSelection.sortField;
    startEnvelopeFilter.sortOrder = sortSelection.sortOrder;

    return startEnvelopeFilter;
  }
}
